import { Box, Text } from '@rsos/base-components';
import { RTI_DOWNSTREAM_SHARE } from '@rsos/constants/collaborator';
import { useCurrentPSAPAccountID } from '@rsos/reduxDataStore/src/features/capstone/psapInfo';
import {
  formatDownstreamAgencyNames,
  isRtiDownstreamSharer,
  useGetSelectedCollaborator,
} from '@rsos/reduxDataStore/src/features/emergencyCalls/helpers';
import { CollapseButton } from '../SharedChatUI/CollapseButton';
import { HeaderContainer, RedCircle } from './CollaboratorChatbox.styles';

const CollaboratorChatHeader = () => {
  const collaborator = useGetSelectedCollaborator();
  const currentAccountId = useCurrentPSAPAccountID();
  const isSharer = isRtiDownstreamSharer(collaborator, currentAccountId);

  // It's one shared conversation across the primary and every downstream
  // agency (see isRtiDownstreamSharer), so a downstream agency's header
  // needs to list every OTHER participant -- the primary plus any other
  // downstream agencies -- not just the primary alone.
  let subtitleName = collaborator.pairedAccountName;
  if (collaborator.type === RTI_DOWNSTREAM_SHARE) {
    subtitleName = isSharer
      ? formatDownstreamAgencyNames(collaborator.downstreamAgencies)
      : formatDownstreamAgencyNames([
          { displayName: collaborator.pairedAccountName ?? '' },
          ...(collaborator.downstreamAgencies ?? []).filter(
            agency => agency.accountID !== currentAccountId,
          ),
        ]);
  }

  return (
    <HeaderContainer data-name="conversations-chat-header" pb="16px" pt="12px">
      <Box horizontal justify="space-between" px="12px" width="100%">
        <Box>
          <Text inline fontWeight="bold">
            <Text color="primaryText" size="normal">
              <RedCircle />
              Agency Live Chat
            </Text>
            <Box horizontal>
              <Text color="secondaryText" fontWeight="regular" size="xsmall">
                {subtitleName}
              </Text>
            </Box>
          </Text>
        </Box>
        <CollapseButton />
      </Box>
    </HeaderContainer>
  );
};

export default CollaboratorChatHeader;
